<div class="pt-[125px] md:pt-[145px] lg:pt-[185px] xl:pt-[195px] text-center">
    <div class="container 2xl:max-w-[1320px] mx-auto px-[12px] relative z-[1]">
        <h1 class="!mb-0 !leading-[1.2] !text-3xl md:!text-5xl lg:!text-[50px] xl:!text-[60px] -tracking-[.5px] md:-tracking-[1px] xl:-tracking-[1.5px]">
            <!--i18n - GENERAL TERMS AND CONDITIONS -->
            {{ 'i18n.app.features.pages.front-pages.legal.term-of-sale.title_page' | translate }}
        </h1>
        <h2 class="!mb-0 !leading-[1.2] !text-3xl md:!text-3xl lg:!text-[25px] xl:!text-[30px] -tracking-[.5px] md:-tracking-[1px] xl:-tracking-[1.5px]">
            <!--i18n - SALE OF FOREIGN CURRENCIES -->
            {{ 'i18n.app.features.pages.front-pages.legal.term-of-sale.sub_title_page' | translate }}
        </h2>
        <div class="absolute bottom-0 -z-[1] ltr:-right-[30px] rtl:-left-[30px] blur-[250px]">
            <img src="images/front-pages/shape3.png" alt="shape3">
        </div>
        <div class="absolute -top-[220px] -z-[1] ltr:-left-[50px] rtl:-right-[50px] blur-[150px]">
            <img src="images/front-pages/shape5.png" alt="shape3">
        </div>
    </div>
</div>

<div class="pb-[60px] md:pb-[80px] lg:pb-[100px] xl:pb-[150px]">
    <div class="container 2xl:max-w-[1320px] mx-auto px-[12px] relative z-[1]">
        <div class="grid grid-cols-1  gap-[25px] items-center">
            <div>
                <ul class="ltr:xl:pl-[18px] rtl:xl:pr-[18px] mt-[25px] md:mt-[30px] lg:mt-[35px] xl:mt-[65px]">

                    <li class="relative ltr:pl-[25px] rtl:pr-[25px] ltr:md:pl-[28px] rtl:md:pr-[28px] ltr:lg:pl-[30px] rtl:lg:pr-[30px] mb-[25px] xl:mb-[32px] last:mb-0">
                        <i class="material-symbols-outlined absolute text-primary-600 !text-[17px] md:!text-lg lg:!text-[20px] ltr:left-0 rtl:right-0 top-0 leading-none">
                            lightbulb
                        </i>
                        <h3 class="!text-[15px] md:!text-md lg:!text-[17px] xl:!text-lg !mb-[8px] md:!mb-[10px] !font-semibold !leading-[1.2]">
                            <!--i18n - Legal notice -->
                            {{ 'i18n.app.features.pages.front-pages.legal.term-of-sale.component.title_01' | translate }}
                        </h3>
                        <p class="!leading-[1.6]  text-gray-500">
                            <!--i18n - Loomis FX, Gold and Services, a public limited company with a Management Board and Supervisory Board with a capital of 4... -->
                            {{ 'i18n.app.features.pages.front-pages.legal.term-of-sale.component.p_01_01' | translate }}
                        </p>
                    </li>

                    <li class="relative ltr:pl-[25px] rtl:pr-[25px] ltr:md:pl-[28px] rtl:md:pr-[28px] ltr:lg:pl-[30px] rtl:lg:pr-[30px] mb-[25px] xl:mb-[32px] last:mb-0">
                        <i class="material-symbols-outlined absolute text-primary-600 !text-[17px] md:!text-lg lg:!text-[20px] ltr:left-0 rtl:right-0 top-0 leading-none">
                            lightbulb
                        </i>
                        <h3 class="!text-[15px] md:!text-md lg:!text-[17px] xl:!text-lg !mb-[8px] md:!mb-[10px] !font-semibold !leading-[1.2]">
                            <!--i18n - Scope -->
                            {{ 'i18n.app.features.pages.front-pages.legal.term-of-sale.component.title_02' | translate }}
                        </h3>
                        <p class="!leading-[1.6]  text-gray-500">
                            <!--i18n - These General Terms and Conditions of Sale (hereinafter referred to as "GTC") are inte... -->
                            {{ 'i18n.app.features.pages.front-pages.legal.term-of-sale.component.p_02_01' | translate }}
                        </p>
                        <p class="!leading-[1.6]  text-gray-500">
                            <!--i18n - Prior to any transaction, the customer expressly acknowledges having read ... -->
                            {{ 'i18n.app.features.pages.front-pages.legal.term-of-sale.component.p_02_02' | translate }}
                        </p>
                        <p class="!leading-[1.6]  text-gray-500">
                            <!--i18n - Loomis FXGS reserves the right to modify these Terms and Conditions at any time ... -->
                            {{ 'i18n.app.features.pages.front-pages.legal.term-of-sale.component.p_02_03' | translate }}
                        </p>
                        <p class="!leading-[1.6]  text-gray-500">
                            <!--i18n - In case of any difference between the French version and the translated versions of this... -->
                            {{ 'i18n.app.features.pages.front-pages.legal.term-of-sale.component.p_02_04' | translate }}
                        </p>
                    </li>

                    <li class="relative ltr:pl-[25px] rtl:pr-[25px] ltr:md:pl-[28px] rtl:md:pr-[28px] ltr:lg:pl-[30px] rtl:lg:pr-[30px] mb-[25px] xl:mb-[32px] last:mb-0">
                        <i class="material-symbols-outlined absolute text-primary-600 !text-[17px] md:!text-lg lg:!text-[20px] ltr:left-0 rtl:right-0 top-0 leading-none">
                            lightbulb
                        </i>
                        <h3 class="!text-[15px] md:!text-md lg:!text-[17px] xl:!text-lg !mb-[8px] md:!mb-[10px] !font-semibold !leading-[1.2]">
                            <!--i18n - Currency ordering procedures -->
                            {{ 'i18n.app.features.pages.front-pages.legal.term-of-sale.component.title_03' | translate }}
                        </h3>
                        <p class="!leading-[1.6] text-gray-500">
                           <!--i18n - Orders can be placed at Bpost post offices or online on t... -->
                           {{ 'i18n.app.features.pages.front-pages.legal.term-of-sale.component.p_03_01' | translate }}
                        </p>
                        <p class="!leading-[1.6] text-gray-500">
                           <!--i18n - Online orders can be placed in French, English, Dutch... -->
                           {{ 'i18n.app.features.pages.front-pages.legal.term-of-sale.component.p_03_02' | translate }}
                        </p>
                    </li>

                    <li class="relative ltr:pl-[25px] rtl:pr-[25px] ltr:md:pl-[28px] rtl:md:pr-[28px] ltr:lg:pl-[30px] rtl:lg:pr-[30px] mb-[25px] xl:mb-[32px] last:mb-0">
                        <i class="material-symbols-outlined absolute text-primary-600 !text-[17px] md:!text-lg lg:!text-[20px] ltr:left-0 rtl:right-0 top-0 leading-none">
                            lightbulb
                        </i>
                        <h3 class="!text-[9px] md:![11px] lg:!text-[13px] xl:!text-[15px] !mb-[8px] md:!mb-[10px] !font-semibold !leading-[1.2]">
                            <!--i18n - Price determination -->
                            {{ 'i18n.app.features.pages.front-pages.legal.term-of-sale.component.title_04' | translate }}
                        </h3>
                        <p class="!leading-[1.6]  text-gray-500">
                            <!--i18n - The selling prices of the currencies are indicated in Euros inclusive of all commis... -->
                            {{ 'i18n.app.features.pages.front-pages.legal.term-of-sale.component.p_04_01' | translate }}
                        </p>
                        <p class="!leading-[1.6]  text-gray-500">
                            <!--i18n - Selling prices vary according to exchange rates and are therefore subject... -->
                            {{ 'i18n.app.features.pages.front-pages.legal.term-of-sale.component.p_04_02' | translate }}
                        </p>
                    </li>

                    <li class="relative ltr:pl-[25px] rtl:pr-[25px] ltr:md:pl-[28px] rtl:md:pr-[28px] ltr:lg:pl-[30px] rtl:lg:pr-[30px] mb-[25px] xl:mb-[32px] last:mb-0">
                        <i class="material-symbols-outlined absolute text-primary-600 !text-[17px] md:!text-lg lg:!text-[20px] ltr:left-0 rtl:right-0 top-0 leading-none">
                            lightbulb
                        </i>
                        <h3 class="!text-[9px] md:![11px] lg:!text-[13px] xl:!text-[15px] !mb-[8px] md:!mb-[10px] !font-semibold !leading-[1.2]">
                            <!--i18n - Payment and execution terms -->
                            {{ 'i18n.app.features.pages.front-pages.legal.term-of-sale.component.title_05' | translate }}
                        </h3>
                        <p class="!leading-[1.6]  text-gray-500">
                            <!--i18n - Payment is due in full and made by bank card at a Bpost post office... -->
                            {{ 'i18n.app.features.pages.front-pages.legal.term-of-sale.component.p_05_01' | translate }}
                        </p>
                    </li>

                    <li class="relative ltr:pl-[25px] rtl:pr-[25px] ltr:md:pl-[28px] rtl:md:pr-[28px] ltr:lg:pl-[30px] rtl:lg:pr-[30px] mb-[25px] xl:mb-[32px] last:mb-0">
                        <i class="material-symbols-outlined absolute text-primary-600 !text-[17px] md:!text-lg lg:!text-[20px] ltr:left-0 rtl:right-0 top-0 leading-none">
                            lightbulb
                        </i>
                        <h3 class="!text-[9px] md:![11px] lg:!text-[13px] xl:!text-[15px] !mb-[8px] md:!mb-[10px] !font-semibold !leading-[1.2]">
                            <!--i18n - Right of withdrawal -->
                            {{ 'i18n.app.features.pages.front-pages.legal.term-of-sale.component.title_06' | translate }}
                        </h3>
                        <p class="!leading-[1.6]  text-gray-500">
                            <!--i18n - Pursuant to Articles VI.58 of the Belgian Code of Economic ... -->
                            {{ 'i18n.app.features.pages.front-pages.legal.term-of-sale.component.p_06_01' | translate }}
                        </p>
                    </li>

                    <li class="relative ltr:pl-[25px] rtl:pr-[25px] ltr:md:pl-[28px] rtl:md:pr-[28px] ltr:lg:pl-[30px] rtl:lg:pr-[30px] mb-[25px] xl:mb-[32px] last:mb-0">
                        <i class="material-symbols-outlined absolute text-primary-600 !text-[17px] md:!text-lg lg:!text-[20px] ltr:left-0 rtl:right-0 top-0 leading-none">
                            lightbulb
                        </i>
                        <h3 class="!text-[9px] md:![11px] lg:!text-[13px] xl:!text-[15px] !mb-[8px] md:!mb-[10px] !font-semibold !leading-[1.2]">
                            <!--i18n - Order confirmation -->
                            {{ 'i18n.app.features.pages.front-pages.legal.term-of-sale.component.title_07' | translate }}
                        </h3>
                        <p class="!leading-[1.6]  text-gray-500">
                            <!--i18n - When the order is confirmed, the customer receives an email notification at the... -->
                            {{ 'i18n.app.features.pages.front-pages.legal.term-of-sale.component.p_07_01' | translate }}
                        </p>
                        <p class="!leading-[1.6]  text-gray-500">
                            <!--i18n - No cancellations are possible once the order has been co... -->
                            {{ 'i18n.app.features.pages.front-pages.legal.term-of-sale.component.p_07_02' | translate }}
                        </p>
                    </li>

                    <li class="relative ltr:pl-[25px] rtl:pr-[25px] ltr:md:pl-[28px] rtl:md:pr-[28px] ltr:lg:pl-[30px] rtl:lg:pr-[30px] mb-[25px] xl:mb-[32px] last:mb-0">
                        <i class="material-symbols-outlined absolute text-primary-600 !text-[17px] md:!text-lg lg:!text-[20px] ltr:left-0 rtl:right-0 top-0 leading-none">
                            lightbulb
                        </i>
                        <h3 class="!text-[9px] md:![11px] lg:!text-[13px] xl:!text-[15px] !mb-[8px] md:!mb-[10px] !font-semibold !leading-[1.2]">
                            <!--i18n - Delivery -->
                            {{ 'i18n.app.features.pages.front-pages.legal.term-of-sale.component.title_08' | translate }}
                        </h3>
                        <p class="!leading-[1.6]  text-gray-500">
                            <!--i18n - Orders are delivered to the selected Bpost post office within .. -->
                            {{ 'i18n.app.features.pages.front-pages.legal.term-of-sale.component.p_08_01' | translate }}
                        </p>
                    </li>

                    <li class="relative ltr:pl-[25px] rtl:pr-[25px] ltr:md:pl-[28px] rtl:md:pr-[28px] ltr:lg:pl-[30px] rtl:lg:pr-[30px] mb-[25px] xl:mb-[32px] last:mb-0">
                        <i class="material-symbols-outlined absolute text-primary-600 !text-[17px] md:!text-lg lg:!text-[20px] ltr:left-0 rtl:right-0 top-0 leading-none">
                            lightbulb
                        </i>
                        <h3 class="!text-[9px] md:![11px] lg:!text-[13px] xl:!text-[15px] !mb-[8px] md:!mb-[10px] !font-semibold !leading-[1.2]">
                            <!--i18n - Order collection -->
                            {{ 'i18n.app.features.pages.front-pages.legal.term-of-sale.component.title_09' | translate }}
                        </h3>
                        <p class="!leading-[1.6]  text-gray-500">
                            <!--i18n - Currency collection takes place at the Bpost post office selected when plac .. -->
                            {{ 'i18n.app.features.pages.front-pages.legal.term-of-sale.component.p_09_01' | translate }}
                        </p>
                        <p class="!leading-[1.6]  text-gray-500">
                            <!--i18n - Currency can only be handed over to the person who placed the order, an .. -->
                            {{ 'i18n.app.features.pages.front-pages.legal.term-of-sale.component.p_09_02' | translate }}
                        </p>
                        <p class="!leading-[1.6]  text-gray-500">
                            <!--i18n - All orders are delivered in a sealed envelope. Acceptance of the order constitutes... -->
                            {{ 'i18n.app.features.pages.front-pages.legal.term-of-sale.component.p_09_03' | translate }}
                        </p>
                        <p class="!leading-[1.6]  text-gray-500">
                            <!--i18n - Orders are made available at Bpost post offices for a maximum period of ten (10)... -->
                            {{ 'i18n.app.features.pages.front-pages.legal.term-of-sale.component.p_09_04' | translate }}
                        </p>
                    </li>

                     <li class="relative ltr:pl-[25px] rtl:pr-[25px] ltr:md:pl-[28px] rtl:md:pr-[28px] ltr:lg:pl-[30px] rtl:lg:pr-[30px] mb-[25px] xl:mb-[32px] last:mb-0">
                        <i class="material-symbols-outlined absolute text-primary-600 !text-[17px] md:!text-lg lg:!text-[20px] ltr:left-0 rtl:right-0 top-0 leading-none">
                            lightbulb
                        </i>
                        <h3 class="!text-[9px] md:![11px] lg:!text-[13px] xl:!text-[15px] !mb-[8px] md:!mb-[10px] !font-semibold !leading-[1.2]">
                            <!--i18n - Unclaimed order -->
                            {{ 'i18n.app.features.pages.front-pages.legal.term-of-sale.component.title_10' | translate }}
                        </h3>
                        <p class="!leading-[1.6]  text-gray-500">
                            <!--i18n - Orders not claimed within ten (10) business days of availability at a Bp ... -->
                            {{ 'i18n.app.features.pages.front-pages.legal.term-of-sale.component.p_10_01' | translate }}
                        </p>
                        <p class="!leading-[1.6]  text-gray-500">
                            <!--i18n - The refund will be made within a maximum of twenty (20) workin .. -->
                            {{ 'i18n.app.features.pages.front-pages.legal.term-of-sale.component.p_10_02' | translate }}
                        </p>
                    </li>

                    <li class="relative ltr:pl-[25px] rtl:pr-[25px] ltr:md:pl-[28px] rtl:md:pr-[28px] ltr:lg:pl-[30px] rtl:lg:pr-[30px] mb-[25px] xl:mb-[32px] last:mb-0">
                        <i class="material-symbols-outlined absolute text-primary-600 !text-[17px] md:!text-lg lg:!text-[20px] ltr:left-0 rtl:right-0 top-0 leading-none">
                            lightbulb
                        </i>
                        <h3 class="!text-[9px] md:![11px] lg:!text-[13px] xl:!text-[15px] !mb-[8px] md:!mb-[10px] !font-semibold !leading-[1.2]">
                            <!--i18n - Ethics – Combating money laundering and the financing of terrorism -->
                            {{ 'i18n.app.features.pages.front-pages.legal.term-of-sale.component.title_11' | translate }}
                        </h3>
                        <p class="!leading-[1.6]  text-gray-500">
                            <!--i18n - The client undertakes to comply with all applicable regulations, including those relatin ... -->
                            {{ 'i18n.app.features.pages.front-pages.legal.term-of-sale.component.p_11_01' | translate }}
                        </p>
                        <p class="!leading-[1.6]  text-gray-500">
                            <!--i18n - In order to enable Loomis FXGS to meet its own legal obligations, the customer  ... -->
                            {{ 'i18n.app.features.pages.front-pages.legal.term-of-sale.component.p_11_02' | translate }}
                        </p>
                        <p class="!leading-[1.6]  text-gray-500">
                            <!--i18n - Loomis FXGS reserves the right to suspend or refuse any transaction if the information ... -->
                            {{ 'i18n.app.features.pages.front-pages.legal.term-of-sale.component.p_11_03' | translate }}
                        </p>
                    </li>

                    <li class="relative ltr:pl-[25px] rtl:pr-[25px] ltr:md:pl-[28px] rtl:md:pr-[28px] ltr:lg:pl-[30px] rtl:lg:pr-[30px] mb-[25px] xl:mb-[32px] last:mb-0">
                        <i class="material-symbols-outlined absolute text-primary-600 !text-[17px] md:!text-lg lg:!text-[20px] ltr:left-0 rtl:right-0 top-0 leading-none">
                            lightbulb
                        </i>
                        <h3 class="!text-[9px] md:![11px] lg:!text-[13px] xl:!text-[15px] !mb-[8px] md:!mb-[10px] !font-semibold !leading-[1.2]">
                            <!--i18n - Dispute resolution -->
                            {{ 'i18n.app.features.pages.front-pages.legal.term-of-sale.component.title_12' | translate }}
                        </h3>
                        <p class="!leading-[1.6]  text-gray-500">
                            <!--i18n - For any difficulty or complaint relating to the sale of foreign currency, the cu ... -->
                            {{ 'i18n.app.features.pages.front-pages.legal.term-of-sale.component.p_12_01' | translate }}
                        </p>
                        <p class="!leading-[1.6]  text-gray-500">
                            <!--i18n - The contact details for this service are as follow  ... -->
                            {{ 'i18n.app.features.pages.front-pages.legal.term-of-sale.component.p_12_02' | translate }}
                        </p>
                        <p class="flex items-center gap-1 text-gray-500 !mb-1">
                            <span class="material-symbols-outlined lg:!text-[17px] xl:!text-lg align-middle text-green-500">
                                target
                            </span>
                            <!--i18n - By phone: +32 9 243 70 80 -->
                           {{ 'i18n.app.features.pages.front-pages.legal.term-of-sale.component.bp_12_01' | translate }}
                        </p>
                        <p class="flex items-center gap-1 text-gray-500 !mb-1">
                            <span class="material-symbols-outlined lg:!text-[17px] xl:!text-lg align-middle text-green-500">
                                target
                            </span>
                            <!--i18n - By email: be.helpdesk@loomis.com -->
                           {{ 'i18n.app.features.pages.front-pages.legal.term-of-sale.component.bp_12_02' | translate }}
                        </p>
                        <p class="!leading-[1.6]  text-gray-500">
                            <!--i18n - Each complaint will be carefully reviewed, and Loomis FXGS will s  ... -->
                            {{ 'i18n.app.features.pages.front-pages.legal.term-of-sale.component.p_12_03' | translate }}
                        </p>
                        <p class="!leading-[1.6]  text-gray-500">
                            <!--i18n - If the customer is not satisfied with the follow-up to their compl  ... -->
                            {{ 'i18n.app.features.pages.front-pages.legal.term-of-sale.component.p_12_04' | translate }}
                        </p>
                        <p class="!leading-[1.6]  text-gray-500">
                            <!--i18n - The complaint file can be sent to the followin... -->
                            {{ 'i18n.app.features.pages.front-pages.legal.term-of-sale.component.p_12_05' | translate }}
                        </p>
                        <p class="!leading-[1.6]  text-gray-500">
                            <!--i18n - Mr. Ombudsman of th... -->
                            {{ 'i18n.app.features.pages.front-pages.legal.term-of-sale.component.p_12_06' | translate }}
                        </p>
                        <p class="!leading-[1.6]  text-gray-500">
                            <!--i18n - Or be contacted online using a specific form on the website https://lem... -->
                            {{ 'i18n.app.features.pages.front-pages.legal.term-of-sale.component.p_12_07' | translate }}
                        </p>
                        <p class="!leading-[1.6]  text-gray-500">
                            <!--i18n - The mediation will be conducted in accordance with the terms of the Mediation ... -->
                            {{ 'i18n.app.features.pages.front-pages.legal.term-of-sale.component.p_12_08' | translate }}
                        </p>
                        <p class="!leading-[1.6]  text-gray-500">
                            <!--i18n - The Ombudsman cannot be contacted if legal proceedings  ... -->
                            {{ 'i18n.app.features.pages.front-pages.legal.term-of-sale.component.p_12_09' | translate }}
                        </p>
                    </li>

                    <li class="relative ltr:pl-[25px] rtl:pr-[25px] ltr:md:pl-[28px] rtl:md:pr-[28px] ltr:lg:pl-[30px] rtl:lg:pr-[30px] mb-[25px] xl:mb-[32px] last:mb-0">
                        <i class="material-symbols-outlined absolute text-primary-600 !text-[17px] md:!text-lg lg:!text-[20px] ltr:left-0 rtl:right-0 top-0 leading-none">
                            lightbulb
                        </i>
                        <h3 class="!text-[9px] md:![11px] lg:!text-[13px] xl:!text-[15px] !mb-[8px] md:!mb-[10px] !font-semibold !leading-[1.2]">
                            <!--i18n - Processing of personal data -->
                            {{ 'i18n.app.features.pages.front-pages.legal.term-of-sale.component.title_13' | translate }}
                        </h3>
                        <p class="!leading-[1.6]  text-gray-500">
                            <!--i18n - Loomis FXGS informs the customer that the personal data concerning him collect ... -->
                            {{ 'i18n.app.features.pages.front-pages.legal.term-of-sale.component.p_13_01' | translate }}
                        </p>
                        <p class="!leading-[1.6]  text-gray-500">
                            <!--i18n - Personal data is kept in accordance with current regulations, namely for six years ... -->
                            {{ 'i18n.app.features.pages.front-pages.legal.term-of-sale.component.p_13_02' | translate }}
                        </p>
                        <p class="!leading-[1.6]  text-gray-500">
                            <!--i18n - They are accessible only to authorized employees of the entities and for the following ... -->
                            {{ 'i18n.app.features.pages.front-pages.legal.term-of-sale.component.p_13_03' | translate }}
                        </p>
                        <p class="flex items-center gap-1 text-gray-500 !mb-1">
                            <span class="material-symbols-outlined lg:!text-[17px] xl:!text-lg align-middle text-green-500">
                                target
                            </span>
                            <!--i18n - Loomis FXGS (foreign currency sales execution) -->
                           {{ 'i18n.app.features.pages.front-pages.legal.term-of-sale.component.bp_13_01' | translate }}
                        </p>
                        <p class="flex items-center gap-1 text-gray-500 !mb-1">
                            <span class="material-symbols-outlined lg:!text-[17px] xl:!text-lg align-middle text-green-500">
                                target
                            </span>
                            <!--i18n - Loomis AB -->
                           {{ 'i18n.app.features.pages.front-pages.legal.term-of-sale.component.bp_13_02' | translate }}
                        </p>
                        <p class="flex items-center gap-1 text-gray-500 !mb-1">
                            <span class="material-symbols-outlined lg:!text-[17px] xl:!text-lg align-middle text-green-500">
                                target
                            </span>
                            <!--i18n - Loomis Belgium (order preparation and transport) -->
                           {{ 'i18n.app.features.pages.front-pages.legal.term-of-sale.component.bp_13_03' | translate }}
                        </p>
                        <p class="flex items-center gap-1 text-gray-500 !mb-1">
                            <span class="material-symbols-outlined lg:!text-[17px] xl:!text-lg align-middle text-green-500">
                                target
                            </span>
                            <!--i18n - Bpost (order placement and delivery) -->
                           {{ 'i18n.app.features.pages.front-pages.legal.term-of-sale.component.bp_13_04' | translate }}
                        </p>
                        <p class="flex items-center gap-1 text-gray-500 !mb-1">
                            <span class="material-symbols-outlined lg:!text-[17px] xl:!text-lg align-middle text-green-500">
                                target
                            </span>
                            <!--i18n - Lexis Nexis (Screening of transactions against sanctions/PEP lists) -->
                           {{ 'i18n.app.features.pages.front-pages.legal.term-of-sale.component.bp_13_05' | translate }}
                        </p>
                        <p class="flex items-center gap-1 text-gray-500 !mb-1">
                            <span class="material-symbols-outlined lg:!text-[17px] xl:!text-lg align-middle text-green-500">
                                target
                            </span>
                            <!--i18n - Stripe (credit card payment processing) -->
                           {{ 'i18n.app.features.pages.front-pages.legal.term-of-sale.component.bp_13_06' | translate }}
                        </p>
                        <p class="!leading-[1.6]  text-gray-500">
                            <!--i18n - This personal data may be disclosed to the competent authorities to comply with legal or regulator ... -->
                            {{ 'i18n.app.features.pages.front-pages.legal.term-of-sale.component.p_13_04' | translate }}
                        </p>
                        <p class="!leading-[1.6]  text-gray-500">
                            <!--i18n - In accordance with the General Data Protection Regulation (GDPR) No. 2016/679, individuals whose ... -->
                            {{ 'i18n.app.features.pages.front-pages.legal.term-of-sale.component.p_13_05' | translate }}
                        </p>
                    </li>
                </ul>
            </div>
        </div>

        <!-- shape :  Tache floue bas droite -->
        <div class="absolute -z-[1] ltr:-right-[30px] rtl:-left-[30px] bottom-[50px] blur-[150px]
                   bg-secondary-400/[0.25] dark:bg-primary-100/[0.25] rounded-full
                   w-[380px] h-[380px]">
        </div>

        <!-- shape : Tache floue haut (remplace shape8) -->
        <div class="absolute -z-[1] ltr:left-[250px] rtl:left-[260px] top-[265px] blur-[175px]
                   bg-secondary-400/[0.25] dark:bg-primary-100/[0.25] rounded-full
                   w-[420px] h-[340px]">
        </div>


        <div class="absolute -top-[60px] ltr:left-[65px] rtl:right-[65px] -z-[1] blur-[150px]">
            <img src="images/front-pages/shape7.png" alt="shape7">
        </div>
        <div class="absolute -bottom-[30px] ltr:right-[20px] rtl:left-[20px] -z-[1] blur-[125px]">
            <img src="images/front-pages/shape8.png" alt="shape8">
        </div>
    </div>
</div>